import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { rupiah, formatDate } from "@/lib/format";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import StatusBadge from "@/components/StatusBadge";
import { Card } from "@/components/ui/card";

export default function ReportKasbon() {
  const [rows, setRows] = useState([]);
  const [emps, setEmps] = useState({});

  useEffect(() => {
    api.get("/cash-advances").then((r) => setRows(r.data));
    api.get("/employees").then((r) => setEmps(Object.fromEntries(r.data.map((e) => [e.id, e.nama]))));
  }, []);

  const totalKasbon = rows.reduce((s, r) => s + Number(r.nominal || 0), 0);
  const totalSisa = rows.reduce((s, r) => s + Number(r.sisa || 0), 0);

  const columns = [
    { key: "nomor", label: "No", sortable: true },
    { key: "employee_id", label: "Pegawai", sortable: true, sortValue: (r) => emps[r.employee_id], render: (r) => emps[r.employee_id] || "-" },
    { key: "tanggal", label: "Tanggal", render: (r) => formatDate(r.tanggal) },
    { key: "nominal", label: "Nominal", align: "right", render: (r) => rupiah(r.nominal) },
    { key: "terpotong", label: "Terpotong", align: "right", render: (r) => rupiah(r.terpotong) },
    { key: "sisa", label: "Sisa", align: "right", render: (r) => rupiah(r.sisa) },
    { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
  ];
  return (
    <div className="space-y-6">
      <PageHeader title="Laporan Kasbon" subtitle="Rekap kasbon & sisa pinjaman pegawai" />
      <div className="grid grid-cols-2 gap-3 max-w-md">
        <Card className="p-4"><div className="text-xs text-slate-500">Total Kasbon</div><div className="text-xl font-black font-mono">{rupiah(totalKasbon)}</div></Card>
        <Card className="p-4"><div className="text-xs text-slate-500">Total Sisa</div><div className="text-xl font-black font-mono text-rose-600">{rupiah(totalSisa)}</div></Card>
      </div>
      <DataTable columns={columns} data={rows} searchKeys={["nomor"]} testid="rep-kasbon-table" />
    </div>
  );
}
